// extracted by mini-css-extract-plugin
module.exports = {"notice":"R6vlS","title":"_7ttj7","controls":"rCxLJ"};